export const dashboardConstants = {
  DASHBOARD_ERROR: 'DASHBOARD_ERROR',
  ANNOUNCEMENT_DETAIL_REQUEST: "ANNOUNCEMENT_DETAIL_REQUEST",
  ANNOUNCEMENT_DETAIL_SUCCESS: "ANNOUNCEMENT_DETAIL_SUCCESS",
  DASHBOARD_INFO_REQUEST: "DASHBOARD_INFO_REQUEST",
  DASHBOARD_INFO_SUCCESS: "DASHBOARD_INFO_SUCCESS",
  SET_CANDIDATE_CUSTOMER_STATE: "SET_CANDIDATE_CUSTOMER_STATE",
  IS_SHOW_MEMBER_APPLICATION: "IS_SHOW_MEMBER_APPLICATION"
};
